import React from "react";
import { useLanguage } from "../../../../contexts";
import "../RiskMatrixGuide/RiskMatrixGuide.scss";

const CRITERIA_ROWS = [
  ["risk_matrix_conesa_in", "IN", "×3"],
  ["risk_matrix_conesa_ex", "EX", "×2"],
  ["risk_matrix_conesa_mo", "MO", "×1"],
  ["risk_matrix_conesa_pe", "PE", "×1"],
  ["risk_matrix_conesa_rv", "RV", "×1"],
  ["risk_matrix_conesa_si", "SI", "×1"],
  ["risk_matrix_conesa_ac", "AC", "×1"],
  ["risk_matrix_conesa_ef", "EF", "×1"],
  ["risk_matrix_conesa_pr", "PR", "×1"],
  ["risk_matrix_conesa_mc", "MC", "×1"],
];

export function ConesaGuide() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  return (
    <div className="risk-matrix-guide">
      <h2>{t("risk_matrix_conesa_guide_title")}</h2>
      <p>{t("risk_matrix_conesa_guide_intro")}</p>
      <p className="risk-matrix-guide__formula">
        I = ±(3·IN + 2·EX + MO + PE + RV + SI + AC + EF + PR + MC)
      </p>
      <ol>
        <li>{t("risk_matrix_conesa_guide_step1")}</li>
        <li>{t("risk_matrix_conesa_guide_step2")}</li>
        <li>{t("risk_matrix_conesa_guide_step3")}</li>
        <li>{t("risk_matrix_conesa_guide_step4")}</li>
      </ol>

      <div className="risk-matrix-guide__note">{t("risk_matrix_conesa_guide_auto_note")}</div>

      <h3>{t("risk_matrix_conesa_guide_criteria_title")}</h3>
      <table className="risk-matrix-guide__table">
        <thead>
          <tr>
            <th>{t("risk_matrix_conesa_guide_criteria_col")}</th>
            <th>{t("risk_matrix_conesa_guide_acronym_col")}</th>
            <th>{t("risk_matrix_conesa_guide_weight_col")}</th>
          </tr>
        </thead>
        <tbody>
          {CRITERIA_ROWS.map(([labelKey, acronym, weight]) => (
            <tr key={acronym}>
              <td>{t(labelKey)}</td>
              <td>{acronym}</td>
              <td>{weight}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="risk-matrix-guide__note">{t("risk_matrix_conesa_guide_ranges")}</div>

      <div className="risk-matrix-guide__ref">{t("risk_matrix_conesa_guide_traceability")}</div>
    </div>
  );
}
